
import { DownloadsCarouselElem, type TranslatedValue } from "@swo/storefront";
import { NonEmptyArray } from "fp-ts/NonEmptyArray";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { PDPDownloadsComponent } from "../../../components/DownloadsCarouselComponent/PDPDownloadsComponent";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

export const ProductDetailPageDownloadsCarousel: ReactTFC<{
  downloadsHeadline: TranslatedValue;
  downloads: NonEmptyArray<DownloadsCarouselElem>;
}> = props => (
  <>
    <Spacer size={"lg"} />
    <PDPDownloadsComponent headline={props.downloadsHeadline} elements={props.downloads} />
  </>
);
